// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CheckDTO } from '../models';
/**
 * ChecksApi - axios parameter creator
 * @export
 */
export const ChecksApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch Check By Id
         * @param {string} id Check id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCheckById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findCheckById.');
            }
            const localVarPath = `/v2/checks/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Override an existing Check By Id
         * @param {string} id Check id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        override(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling override.');
            }
            const localVarPath = `/v2/checks/{id}/override`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecksApi - functional programming interface
 * @export
 */
export const ChecksApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Fetch Check By Id
         * @param {string} id Check id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCheckById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckDTO> {
            const localVarAxiosArgs = ChecksApiAxiosParamCreator(configuration).findCheckById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Override an existing Check By Id
         * @param {string} id Check id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        override(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckDTO> {
            const localVarAxiosArgs = ChecksApiAxiosParamCreator(configuration).override(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * ChecksApi - factory interface
 * @export
 */
export const ChecksApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Fetch Check By Id
         * @param {string} id Check id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCheckById(id: string, options?: any) {
            return ChecksApiFp(configuration).findCheckById(id, options)(axios, basePath);
        },
        /**
         * Override an existing Check By Id
         * @param {string} id Check id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        override(id: string, options?: any) {
            return ChecksApiFp(configuration).override(id, options)(axios, basePath);
        },
    };
};

/**
 * ChecksApi - interface
 * @export
 * @interface ChecksApi
 */
export interface ChecksApiInterface {
    /**
     * Fetch Check By Id
     * @param {string} id Check id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecksApiInterface
     */
    findCheckById(id: string, options?: any): AxiosPromise<CheckDTO>;

    /**
     * Override an existing Check By Id
     * @param {string} id Check id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecksApiInterface
     */
    override(id: string, options?: any): AxiosPromise<CheckDTO>;

}

/**
 * ChecksApi - object-oriented interface
 * @export
 * @class ChecksApi
 * @extends {BaseAPI}
 */
export class ChecksApi extends BaseAPI implements ChecksApiInterface {
    /**
     * Fetch Check By Id
     * @param {string} id Check id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecksApi
     */
    public findCheckById(id: string, options?: any) {
        return ChecksApiFp(this.configuration).findCheckById(id, options)(this.axios, this.basePath);
    }

    /**
     * Override an existing Check By Id
     * @param {string} id Check id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChecksApi
     */
    public override(id: string, options?: any) {
        return ChecksApiFp(this.configuration).override(id, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for ChecksApi
 * Import individual functions for optimal bundle size
 */
/**
 * Fetch Check By Id
 * @param {string} id Check id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findCheckById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<CheckDTO> {
    const localVarAxiosArgs = ChecksApiAxiosParamCreator(configuration).findCheckById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Override an existing Check By Id
 * @param {string} id Check id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function override(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<CheckDTO> {
    const localVarAxiosArgs = ChecksApiAxiosParamCreator(configuration).override(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

